import { ArrowRight, Bitcoin } from 'lucide-react'
import { Link } from 'react-router-dom'

interface CryptoPaymentHelperProps {
  to?: string
  className?: string
}

export function CryptoPaymentHelper({ to, className }: CryptoPaymentHelperProps) {
  const content = (
    <div className="flex items-start gap-3">
      <div className="flex h-8 w-8 shrink-0 items-center justify-center rounded-md bg-orange-500/10">
        <Bitcoin className="h-4 w-4 text-orange-600 dark:text-orange-400" />
      </div>
      <div className="min-w-0 flex-1">
        <p className="text-xs font-semibold text-orange-900 dark:text-orange-200">
          Selling peptides, nutras, or running online games?
        </p>
        <p className="mt-0.5 text-[11px] leading-relaxed text-orange-700 dark:text-orange-300/80">
          <span className="font-bold">Card to crypto</span> is perfect for high-risk verticals like peptides, nutras, and online gaming (casino, etc.). Accept <span className="font-bold">card payments</span> with <span className="font-bold">USDC settlement in just a few hours</span> — no crypto knowledge needed from your customers.
        </p>
        {to && (
          <span className="mt-1.5 inline-flex items-center gap-1 text-[11px] font-medium text-orange-600 transition-colors hover:text-orange-800 dark:text-orange-400 dark:hover:text-orange-200">
            Set it up
            <ArrowRight className="h-3 w-3" />
          </span>
        )}
      </div>
    </div>
  )

  const baseClassName = `rounded-lg border border-orange-200 bg-gradient-to-r from-orange-50 to-amber-50 p-3 dark:border-orange-800/40 dark:from-orange-950/30 dark:to-amber-950/20 ${className ?? ''}`

  if (to) {
    return (
      <Link to={to} className={`block ${baseClassName}`}>
        {content}
      </Link>
    )
  }

  return (
    <div className={baseClassName}>
      {content}
    </div>
  )
}
